/** Root Stock Nos Count: count packed root stock that has no seed count yet, and the counts made. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { RootStockCountPage } from "@/features/packaging/components/root-stock-count-page";

export const Route = createFileRoute("/_app/packaging/root-stock-count/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return <RootStockCountPage facilityId={selected?.id} />;
}
